import { get } from 'lodash';

import { scriptTypes } from 'constants/scripts';

import { getActiveScriptType, getSelectedTrialPlacement, getActiveFieldUuid } from 'current/selectors';
import { getFieldByUuid } from 'fields/selectors';

export const getStep = (state) =>
  get(state, 'scriptFlow.activeStep.stepNumber'); // TODO: CFVWEB-3365 Update to use getStepNumber from via script-flow

export const getShowConfirmModal = (state) => get(state, 'experiment.showConfirmModal');

export const getPrescriptionStatus = (state) => get(state, 'experiment.prescriptionStatus');

export const getError = (state) => get(state, 'experiment.error');

export const canGoBack = (state) => {
  return !(getStep(state) === 1
    && getActiveScriptType(state) === scriptTypes.EXPERIMENT);
};

export const getExperimentApplication = (state) => get(state, 'experiment.application.selectedProduct');

export const getExperimentApplicationDate = (state) => get(state, 'experiment.application.date');

export const getExperimentApplicationRate = (state) => get(state, 'experiment.application.rate');

export const getExperimentApplicationType = (state) => get(state, 'experiment.application.type');

export const getExperimentScriptName = (state) => {
  const fieldName = getFieldByUuid(state, getActiveFieldUuid(state)).name;
  const applicationDateTime = getExperimentApplicationDate(state);
  const applicationDate = applicationDateTime.split('T')[0];

  return `${fieldName.toLowerCase().replaceAll(' ', '-')}-${applicationDate}`;
};

export const canGoForward = (state) => {
  const scriptType = getActiveScriptType(state);
  const step = getStep(state);

  if (scriptType === scriptTypes.EXPERIMENT && step === 1) {
    const experimentApplication = getExperimentApplication(state);
    if (experimentApplication.id) {
      return true;
    }
  }

  if (scriptType === scriptTypes.EXPERIMENT && step === 2) {
    const selectedTrialPlacement = getSelectedTrialPlacement(state);
    if (selectedTrialPlacement) {
      return true;
    }
  }

  if (scriptType === scriptTypes.EXPERIMENT && step === 3) {
    const experimentApplicationRate = getExperimentApplicationRate(state);
    if (experimentApplicationRate > 0) {
      return true;
    }
  }

  return false;
};
